import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Divider } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Icon from "@shared/components/Icon";
import Typography from "@mui/material/Typography";
import Link from "@shared/components/contents/link/Link";
import { getDateFromTimestamp } from "@shared/utils/commonUtils";
import { Stack } from "@mui/system";
const ArticleCard = ({ page, direction = "vertical", principal = false, }) => {
    const { image, title, created = "" } = page;
    const date = getDateFromTimestamp(created, "DD MMM YYYY");
    let gridSize = 4;
    if (principal) {
        gridSize = 6;
    }
    if (direction === "horizontal") {
        gridSize = 12;
    }
    return (_jsx(Grid, { size: gridSize, children: _jsxs(Card, { component: Link, page: page, sx: {
                display: "block",
                height: "100%",
                border: "solid 1px",
                borderColor: "border.grey",
                boxShadow: "none",
                "&:hover, &:focus": {
                    border: "solid 1px",
                    borderColor: "border.soft",
                    textDecoration: "none",
                },
            }, children: [image?.url && (_jsx(CardMedia, { component: "img", image: image.url, alt: image.alt || "", title: image.title, sx: { height: principal ? 400 : 200, objectFit: "cover" } })), _jsx(CardContent, { sx: { p: 3 }, children: _jsx(Stack, { alignItems: "center", spacing: 1, children: _jsxs(Stack, { spacing: 2.5, sx: { width: "100%", alignItems: "stretch" }, children: [title && (_jsx(Typography, { variant: "subtitle1", component: "h2", sx: { mt: 1, alignSelf: "flex-start" }, children: title })), _jsx(Divider, { sx: { backgroundColor: "border.separator" } }), _jsxs(Stack, { spacing: 1, children: [created && (_jsx(Typography, { variant: "caption", component: "p", alignSelf: "flex-start", sx: { fontSize: "16px" }, children: date })), _jsx(Button, { variant: "text", endIcon: _jsx(Icon, { icon: "arrow-right" }), component: Link, page: page, sx: {
                                                alignSelf: "flex-end",
                                                color: "primary.main",
                                                "&:hover": {
                                                    backgroundColor: "transparent",
                                                },
                                                "&:focus": {
                                                    outline: "2px solid",
                                                    outlineColor: "primary.main",
                                                },
                                            }, children: "Lire l'article" })] })] }) }) })] }) }));
};
export const PrincipalArticleCard = (props) => _jsx(ArticleCard, { ...props, principal: true });
export const ArticleCardSkeleton = ({ direction = "vertical", }) => (_jsx(Grid, { size: direction === "horizontal" ? 12 : 4, "aria-hidden": "true", children: _jsxs(Card, { sx: {
            height: "100%",
            border: "solid 1px",
            borderColor: "border.grey",
            boxShadow: "none",
        }, children: [_jsx(Skeleton, { variant: "rectangular", height: 200 }), _jsxs(CardContent, { sx: { p: 3 }, children: [_jsx(Skeleton, { variant: "rounded", width: 80, height: 24 }), _jsxs(Stack, { spacing: 2.5, sx: { mt: 1 }, children: [_jsxs(Typography, { variant: "subtitle1", component: "div", children: [_jsx(Skeleton, { width: "90%" }), _jsx(Skeleton, { width: "65%" })] }), _jsx(Divider, { sx: { backgroundColor: "border.separator" } }), _jsxs(Stack, { spacing: 1, children: [_jsx(Skeleton, { width: 110, height: 24 }), _jsx(Skeleton, { width: 140, height: 36, sx: { alignSelf: "flex-end" } })] })] })] })] }) }));
export default ArticleCard;
